import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import { Modal, Button, Form } from "react-bootstrap";
import AdminHeader from "../../common/AdminHeader";
import Footer from "../../common/Footer";
import { baseUrl } from "../../../Utility/constants";

const BonafideReasonMaster = ({ type, title }) => {
  const [list, setList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const [model, setModel] = useState({
    id: 0,
    name: "",
    isActive: true,
  });

  const apiUrl = `${baseUrl}/api/BonafideReasonMaster`;

  useEffect(() => {
    fetchData();
  }, [type]);

  const fetchData = async () => {
    try {
      const res = await axios.get(apiUrl);
      setList(res.data);
    } catch (err) {
      toast.error("Failed to load data");
    }
  };

  const handleShowModal = (item = null) => {
    if (item) {
      setModel(item);
      setIsEdit(true);
    } else {
      setModel({
        id: 0,
        name: "",
        isActive: true,
      });
      setIsEdit(false);
    }
    setShowModal(true);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setModel({
      ...model,
      [name] : value,
    });
  };

  const handleSubmit = async () => {
    if (!model.name.trim()) {
      toast.warning("Please enter name");
      return;
    }

    try {
      if (isEdit) {
        await axios.put(`${apiUrl}/${model.id}`, model);
        toast.success("Updated successfully");
      } else {
        await axios.post(apiUrl, model);
        toast.success("Added successfully");
      }

      fetchData();
      setShowModal(false);
    } catch (err) {
      toast.error(err.response?.data || "Failed to save record");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this record?")) return;

    try {
      await axios.delete(`${apiUrl}/${id}`);
      toast.success("Deleted successfully");
      fetchData();
    } catch {
      toast.error("Failed to delete record");
    }
  };

  return (
    <>
      <AdminHeader />

      <div className="container mt-5">
        <div className="d-flex justify-content-between mb-3">
          <h4>{title}</h4>
          <Button onClick={() => handleShowModal()}>Add</Button>
        </div>

        <table className="table table-bordered table-striped">
          <thead className="table-dark">
            <tr>
              <th>#</th>
              <th>Name</th>
              <th width="160">Actions</th>
            </tr>
          </thead>
          <tbody>
            {list.length === 0 && (
              <tr>
                <td colSpan="4" className="text-center">
                  No records found
                </td>
              </tr>
            )}

            {list.map((item, index) => (
              <tr key={item.id}>
                <td>{index + 1}</td>
                <td>{item.name}</td>               
                <td>
                  <Button
                    size="sm"
                    variant="warning"
                    className="me-2"
                    onClick={() => handleShowModal(item)}
                  >
                    Edit
                  </Button>
                  <Button
                    size="sm"
                    variant="danger"
                    onClick={() => handleDelete(item.id)}
                  >
                    Delete
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            {isEdit ? "Edit" : "Add"} {title}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Name</Form.Label>
              <Form.Control
                name="name"
                value={model.name}
                onChange={handleChange}
              />
            </Form.Group>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button onClick={handleSubmit}>
            {isEdit ? "Update" : "Save"}
          </Button>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      <Footer />
      <ToastContainer />
    </>
  );
};

export default BonafideReasonMaster;
